import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { map, startWith } from 'rxjs/operators';
import { User } from 'anchor-shared/lib/model/entity/user';
import { Observable, Subscription } from 'rxjs';
import { Payout } from 'anchor-shared/lib/model/entity/payout';
import { FormControl } from '@angular/forms';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { MatOptionSelectionChange } from '@angular/material/core';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';

@Component({
  selector: 'app-payee-selection',
  templateUrl: './payee-selection.component.html',
  styleUrls: ['./payee-selection.component.scss'],
})
export class PayeeSelectionComponent implements OnInit, OnDestroy {
  @Input()
  vessel: Vessel;

  @Output()
  payeeSelection = new EventEmitter<PayeeSelectionResult>();

  payout: Payout;
  myControl: FormControl = new FormControl();
  userOptions: any;
  payeeType: string;
  payeeSelectionResult: PayeeSelectionResult;

  filteredUsers: Observable<User[]>;
  userSub: Subscription;
  selectedUser: User;
  lineItemPayees = ['Boat Owner', 'Captain', 'Anchor', 'Specific User'];

  constructor(private userDao: UserDAO) {}

  ngOnInit() {
    this.payeeType = this.vessel.fuelPayeeType
      ? this.vessel.fuelPayeeType
      : 'Boat Owner';
    this.userSub = this.userDao.getUsersForPayouts().subscribe((data) => {
      data.forEach((user) => {
        if (user.id === this.vessel.fuelPayeeUserId) {
          this.selectedUser = user;
          this.myControl.setValue(
            user.firstName +
              user.lastName +
              ' | ' +
              (user.paypalEmail ? user.paypalEmail : ''),
          );
        }
      });
      this.userOptions = data;
      this.filteredUsers = this.myControl.valueChanges.pipe(
        startWith(''),
        map((val) => (val && val.length >= 4 ? this._filter(val) : [])),
      );
    });
  }

  _filter(val: string): User[] {
    return this.userOptions.filter((s) =>
      new RegExp(val, 'gi').test(s.firstName + ' ' + s.lastName),
    );
  }

  ngOnDestroy(): void {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
  }

  selectPayeeType(event: MatOptionSelectionChange): void {
    if (event.isUserInput) {
      if (this.payeeSelectionResult) {
        this.payeeSelectionResult.payeeType = event.source.value;
        this.payeeSelection.emit(this.payeeSelectionResult);
      } else {
        this.payeeSelectionResult = {
          payeeType: event.source.value,
        };
        this.payeeSelection.emit(this.payeeSelectionResult);
      }
    }
  }

  selectUser(event: MatOptionSelectionChange, user: User) {
    if (event.isUserInput) {
      this.selectedUser = user;
      this.payeeSelectionResult.user = user;
      this.payeeSelection.emit(this.payeeSelectionResult);
    }
  }
}

export interface PayeeSelectionResult {
  payeeType: string;
  user?: User;
}
